export const mutations = {
    writeInfoAssessment(state, data) {
        state.infoAssessment["decorationType"] = data.decorationType;
    },
};
